import type { WavespeedModel, WavespeedParam } from '@/lib/ai/wavespeed';

export const isMediaParam = (param: WavespeedParam) =>
  param.widget === 'media-list' || param.widget === 'image-url';

const hasValue = (value: unknown) => value !== undefined && value !== null && value !== '' &&
  (!Array.isArray(value) || value.length > 0);

/** Choose a live endpoint and build one payload for both preview and submit. */
export function resolveGeneration(model: WavespeedModel | undefined, values: Record<string, any>) {
  if (!model) return { modelId: '', params: {}, schema: [] as WavespeedParam[] };
  let modelId = model.id;
  const alternate = model.variants?.edit ?? model.variants?.i2v;
  const primarySchema = model.schema ?? [];
  const alternateSchema = alternate ? model.variantSchemas?.[alternate] ?? [] : [];
  const alternateInput = alternateSchema.some((p) => isMediaParam(p) && hasValue(values[p.key]) &&
    !primarySchema.some((primary) => primary.key === p.key));
  if (alternate && alternateInput) modelId = alternate;
  const schema = model.variantSchemas?.[modelId] ?? primarySchema;
  const params: Record<string, any> = {};
  for (const param of schema) {
    const value = values[param.key];
    if (hasValue(value)) params[param.key] = value;
    else if (param.default !== undefined && param.default !== null) params[param.key] = param.default;
  }
  return { modelId, params, schema };
}

export function referenceParams(model: WavespeedModel | undefined, schema: WavespeedParam[]) {
  const alternate = model?.variants?.edit ?? model?.variants?.i2v;
  const alternateSchema = alternate ? model?.variantSchemas?.[alternate] ?? [] : [];
  const params = [...schema, ...alternateSchema].filter(isMediaParam);
  return [...new Map(params.map((p) => [p.key, p])).values()];
}

export function formatUsd(value: number) {
  return `$${value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 8 })}`;
}
